var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleAngleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 3.21875L11.3438 9.75C11.4688 9.90625 11.4688 10.125 11.3438 10.2812L4.78125 16.8125C4.65625 16.9688 4.40625 16.9688 4.25 16.8125L3.625 16.2188C3.5 16.0625 3.5 15.8125 3.625 15.6875L9.28125 10L3.625 4.34375C3.5 4.21875 3.5 3.96875 3.625 3.8125L4.25 3.21875C4.40625 3.0625 4.65625 3.0625 4.78125 3.21875ZM9.25 3.21875C9.40625 3.0625 9.65625 3.0625 9.78125 3.21875L16.3438 9.75C16.4688 9.90625 16.4688 10.125 16.3438 10.2812L9.78125 16.8125C9.65625 16.9688 9.40625 16.9688 9.25 16.8125L8.625 16.2188C8.5 16.0625 8.5 15.8125 8.625 15.6875L14.2812 10L8.625 4.34375C8.5 4.21875 8.5 3.96875 8.625 3.8125L9.25 3.21875Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleAngleArrowRight);
export default __webpack_public_path__ + "static/media/double-angle-arrow-right.989dffd3.svg";
export { ForwardRef as ReactComponent };